/**
 * Forbidden Page
 *
 * Displayed when a user is authenticated but lacks the required
 * permissions/role to access a resource (403 Forbidden).
 */

import { ScreenContainer } from "@src/components/ScreenContainer";
import { ForbiddenContent } from "@src/features/auth/components/ForbiddenContent";

export default function ForbiddenScreen() {
  return (
    <ScreenContainer edges={["top"]}>
      <ForbiddenContent />
    </ScreenContainer>
  );
}
